module.exports = __webpack_public_path__ + "img/AsylumVol2.ec8d6f5b.jpg";